<template>
    <p class="outside-icon" :class="phoneTypeClass">
        <a :href="'tel:' + phone.value.replace(/[-+()\s]/g, '')">{{phone.value}}</a> <span
            class="sub-info">{{phone.type === 'work' ? 'рабочий' : 'личный'}}</span>
    </p>
</template>

<script>

    export default {
        name: 'phone-item',
        data() {
            return {
                edit: false,
                text: ''
            }
        },
        computed: {
            phoneTypeClass() {
                return this.phone.type === 'work' ? 'font-icon-work-tel' : 'font-icon-personal-tel'
            }
        },
        props: {
            phone: Object,
        },
        /*methods: {
            editCLick() {
                if (this.edit) {
                    this.$emit('edit', this.text)
                }
                this.edit = !this.edit;
            },
            enterHandle() {
                this.$emit('edit', this.text)
                this.edit = !this.edit;
            }
        },
        created() {
            this.text = this.note.text
        }*/
    }
</script>

<style scoped>

    .notes-container .edit-link {
        margin-left: 50px;
    }

</style>
